import { createContext } from 'react'
import { BrowserRouter as Router, Routes } from 'react-router-dom'
import { renderSiteMap, mainLayoutRoute } from './routes'
import { Libraries, useJsApiLoader } from '@react-google-maps/api'

export const AppContext = createContext<{
  isGoogleMapAPILoaded: boolean
  googleMapAPILoadError: Error | undefined
}>({
  isGoogleMapAPILoaded: false,
  googleMapAPILoadError: undefined,
})

const libraries: Libraries = ['drawing', 'places']

function App() {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '',
    libraries: libraries,
  })

  return (
    // @ts-ignore
    <AppContext.Provider value={{ isGoogleMapAPILoaded: isLoaded, googleMapAPILoadError: loadError }}>
      <Router>
        <Routes>{renderSiteMap({ mainLayoutRoute })}</Routes>
      </Router>
    </AppContext.Provider>
  )
}

export default App
